import api from '../../lib/api';

export const getActivities = (pathway, type, favourites, nameSearch, pageNumber) =>
  function get(dispatch) {
    const strType = (type ? `&type=${type.replace(/ /g, '%20')}` : '');
    const favouriteStr = (favourites ? `&favourites=${favourites.join(',')}` : '');
    const nameStr = (nameSearch ? `&name=${nameSearch}` : '');
    const pageStr = (pageNumber ? `&page=${pageNumber}` : '');
    const limit = (window.innerWidth < 630 ? 3 : 6);
    api
      .proxyGet(`/directory?limit=${limit}&${pathway}=yes${strType}${favouriteStr}${nameStr}${pageStr}`)
      .then(response => dispatch(getActivitiesSuccess(response.data)))
      .catch(error => console.error(error));
  };

export const getActivitiesSuccess = data => ({
  type: 'GET_ACTIVITIES_SUCCESS',
  data,
});


export const getFilters = pathway =>
  function get(dispatch) {
    api
      .proxyGet(`/directory?filter=1&limit=6&${pathway}=yes`)
      .then(response => dispatch(getActivityFilterSuccess(response.data)))
      .catch(error => console.error(error));
  };

export const getActivityFilterSuccess = data => ({
  type: 'GET_ACTIVITY_FILTERS_SUCCESS',
  data,
});

export const changeFilter = id => ({
  type: 'CHANGE_ACTIVITY_FILTER',
  id,
});

export const updateFavourite = activityId =>
  function get(dispatch) {
    api
      .sendPost('/public-dashboard/favourite/activity', { activity_id: activityId }, (error, response) => {
        if (error) return console.error(error);
        return dispatch(getFavourites());
      });
  };

export const getFavourites = () =>
  function get(dispatch) {
    api
      .sendGet('/public-dashboard/favourite/activity', (error, response) => {
        if (error) return console.error(error);
        return dispatch(getFavouritesSuccess(response.data));
      });
  };

export const getFavouritesSuccess = data => ({
  type: 'GET_ACTIVITY_FAVOURITES_SUCCESS',
  data,
});



// WEBPACK FOOTER //
// ./src/Actions/Dashboard/activities.js